import { render } from "./MaskIcon.vue?vue&type=template&id=39e665f9&scoped=true"
import script from "./MaskIcon.vue?vue&type=script&lang=js"
export * from "./MaskIcon.vue?vue&type=script&lang=js"

import "./MaskIcon.vue?vue&type=style&index=0&id=39e665f9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e665f9"]])

export default __exports__